module.exports = __webpack_public_path__ + "fonts/Lato-BoldItalic.5ca6a1d0.eot";